// extracted by mini-css-extract-plugin
module.exports = {"body":"HomePage_body__8wd00","container":"HomePage_container__2NzmM"};